import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/guagua";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleMenu = () => setMenuOpen((v) => !v);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-18 items-center justify-between px-4 md:px-6">
        <a
          href="#home"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="吃瓜视频网首页"
        >
          <span className="grid h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-bubble-chart-fill text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
          >
            吃瓜视频网
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors hover:bg-primary-100/60 hover:text-primary-700 ${
                scrolled ? "text-foreground-700" : "text-background-50/90"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#video"
            className={`hidden md:inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
              scrolled
                ? "bg-accent-500 text-background-50 hover:bg-accent-600"
                : "bg-background-50 text-foreground-900 hover:bg-background-200"
            }`}
          >
            <i className="ri-video-add-line" aria-hidden="true"></i>
            围观现场
          </a>
          <button
            type="button"
            onClick={toggleMenu}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            className={`grid h-10 w-10 items-center justify-center rounded-full lg:hidden transition-colors ${
              scrolled
                ? "text-foreground-900 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/20"
            }`}
          >
            <i
              className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}
              aria-hidden="true"
            ></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md px-4 py-3">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={toggleMenu}
                className="rounded-lg px-4 py-3 text-sm text-foreground-700 hover:bg-primary-100/60 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={toggleMenu}
              className="mt-2 rounded-lg bg-accent-500 px-4 py-3 text-center text-sm text-background-50 hover:bg-accent-600"
            >
              订阅热点
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;